import React from 'react';
import { Route, Switch } from 'react-router-dom';
import AuthRoute from 'utils/auth/authRoute';
import { UsersList } from 'pages/usersV1/list';
import { UserProfile } from 'pages/usersV1/user/User';
import { PageError } from '../../pages/index';

export const UsersRouterV1 = ({ match, useCase, organizationId }) => {
    const { path } = match;

    return (
        <Switch>
            <AuthRoute allow={['RoleCapacity.ADMIN', 'RoleCapacity.OWNER']} exact path={path} render={() => <UsersList organizationId={organizationId} useCase={useCase} />} />
            <AuthRoute
                exact
                allow={['RoleCapacity.ADMIN', 'RoleCapacity.OWNER']}
                path={`${path}/:userId`}
                render={({
                    match: {
                        params: { userId }
                    }
                }) => <UserProfile useCase={useCase} organizationId={organizationId} userId={userId} />}
            />
            <Route render={() => <PageError backHomeUrl={'/'} />} />
        </Switch>
    );
};
